import placholderImage from "../assets/graphics/coin_placeholder.png";

export const getCoinImage = (coinName: string | undefined): string => {
  if (!coinName) {
    return placholderImage;
  }
  coinName = coinName.replace("DOWN", "").replace("UP", "");
  const symbol = coinName.toLowerCase();
  switch (symbol) {
    case "shib":
      return "https://raw.githubusercontent.com/coinwink/cryptocurrency-logos/master/coins/128x128/5994.png";
    case "ftm":
      return "https://atomicwallet.io/images/crypto-icons/FTM.svg";
    case "egld":
      return "https://atomicwallet.io/images/crypto-icons/EGLD.svg";
    case "near":
      return "https://atomicwallet.io/images/crypto-icons/NEAR.svg";
    case "arb":
      return "https://seeklogo.com/images/A/arbitrum-arb-logo-1AA8787597-seeklogo.com.png";
    case "rndr":
      return "https://s2.coinmarketcap.com/static/img/coins/200x200/5690.png";
    case "spell":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/11289.png";
    case "pepe":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/24478.png";
    case "wif":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/28752.png";
    case "alice":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/27204.png";
    case "hive":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/5370.png";
    case "ygg":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/10988.png";
    case "sxp":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/4279.png";
    case "twt":
      return "https://research.binance.com/static/images/projects/trustwallet/logo.png";
    case "hbar":
      return "https://atomicwallet.io/images/crypto-icons/HBAR.svg";
    case "alpha":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/20314.png";
    case "luna":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/4172.png";
    case "rad":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/6843.png";
    case "chess":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/1297.png";
    case "reef":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/6951.png";
    case "city":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/10049.png";
    case "rune":
      return "https://atomicwallet.io/images/crypto-icons/RUNE.svg";
    case "pyr":
      return "https://d235dzzkn2ryki.cloudfront.net/vulcan-forged_large.png";
    case "gala":
      return "https://atomicwallet.io/images/crypto-icons/GALA.svg";
    case "inj":
      return "https://atomicwallet.io/images/crypto-icons/INJ.svg";
    case "ens":
      return "https://cryptologos.cc/logos/ethereum-name-service-ens-logo.png";
    case "icp":
      return "https://s2.coinmarketcap.com/static/img/coins/64x64/8916.png";
    case "tlm":
      return " https://s2.coinmarketcap.com/static/img/coins/64x64/10929.png";

    default:
      return `https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/${symbol}.png`;
  }
};

export default getCoinImage;
